import request from "@/utils/request"
//订单列表
export function orderPagerList(data) {
  return request({
    url:'/order/orderPagerList',
    method:'post',
    data
  })
}


//绑定支付宝账号
export function bindAliPay(data) {
  return request({
    url:'/user/bindAliPay',
    method:'post',
    data
  })
}
//绑定支付宝获取验证码
export function getBindAliPayVerifyCode(data) {
  return request({
    url:'/user/getBindAliPayVerifyCode',
    method:'post',
    data
  })
}
//查询粉丝用户列表
export function getUserInviteList(data) {
  return request({
    url:'/user/getUserInviteList',
    method:'post',
    data
  })
}
//邀请
export function getWeXinQrCode(data) {
  return request({
    url:'/user/getWeXinQrCode',
    method:'post',
    data
  })
}